import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { handleUserLevelAccessPermissions, getFormattedDate, changeDateFormat, isEndDateGreater } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { generateExcel } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

const DistrictIndex = () => {
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const [isDivision, setIsDivision] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [buttonAccess, setButtonAccess] = useState(false);
  const storedLanguage = localStorage.getItem('language');
  const today = new Date();
  const config = getAuthHeaders();



  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)
    if (level.userLevel === "DIVISION LEVEL" && level.roles.includes("DIVADM")) {
      setIsDivision(true);
    }
  }, []);



  const formatGrossValue = (value) => {
    if (value === 0) return "0.00";
    if (value === "NaN") return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(2);
  };

  //handle excel sheet ***************
  const handleGenerateExcel = () => {
    if (!startDate || !endDate) {
      toast.error('Please select the date range', messages.COLOR_RED);
      return;
    }

    if (!isEndDateGreater(startDate, endDate)) {
      toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
      return;
    }

    showLoading(true);
    let sDate = getFormattedDate(startDate);
    let eDate = getFormattedDate(endDate);
    const payload = {
      fromDate: sDate,
      toDate: eDate,
    };

    axios
      .post(`${API_URL}api/price/getRuralDistrictIndex`, payload, config)
      .then((response) => {
        const reportData = response.data;
        console.warn("sssssssssssssssssssss", reportData)

        if (reportData.status) {
          const groupCodes = reportData.data.GroupCodes[0];
          console.warn("OOOOOOOOOOOOOOO", groupCodes)
          const headers = Object.keys(groupCodes);
          const headerEnglishColumns = headers.map(key => groupCodes[key]);

          const [firstObject, ...restOfArray] = reportData.data.GroupCodes;
          const additionalData = restOfArray.map(item => [
            item.distMonth,
            item.strDate,
            item.districtName,
            formatGrossValue(item.all_index),
            formatGrossValue(item.food_beverages_and_tobacco_index),
            formatGrossValue(item.cereals_and_products_index),
            formatGrossValue(item.wheat_index),
            formatGrossValue(item.rice_arwa_index),
            formatGrossValue(item.gram_whole_index),
            formatGrossValue(item.maize_index),
            formatGrossValue(item.bajra_index),
            formatGrossValue(item.pulses_and_products_index),
            formatGrossValue(item.arhar_dal_index),
            formatGrossValue(item.urd_dal_index),
            formatGrossValue(item.masur_dal_index),
            formatGrossValue(item.pea_dal_index),
            formatGrossValue(item.moong_dal_index),
            formatGrossValue(item.gram_dal_index),
            formatGrossValue(item.milk_and_milk_products_index),
            formatGrossValue(item.milk_index),
            formatGrossValue(item.ghee_index),
            formatGrossValue(item.oils_and_fats_index),
            formatGrossValue(item.mustard_oil_index),
            formatGrossValue(item.vanaspati_ghee_index),
            formatGrossValue(item.meats_fish_and_eggs_index),
            formatGrossValue(item.goat_meat_index),
            formatGrossValue(item.fish_rohu_index),
            formatGrossValue(item.eggs_index),
            formatGrossValue(item.vegetables_index),
            formatGrossValue(item.potato_index),
            formatGrossValue(item.tomato_index),
            formatGrossValue(item.onion_index),
            formatGrossValue(item.brinjal_index),
            formatGrossValue(item.chillis_index),
            formatGrossValue(item.fruits_and_dry_fruits_index),
            formatGrossValue(item.apple_index),
            formatGrossValue(item.banana_index),
            formatGrossValue(item.mango_index),
            formatGrossValue(item.groundnut_index),
            formatGrossValue(item['coconut_(copra)_index']),
            formatGrossValue(item.sugar_and_gur_etc_index),
            formatGrossValue(item.sugar_index),
            formatGrossValue(item.gur_index),
            formatGrossValue(item.condiments_and_spices_index),
            formatGrossValue(item['corriander_(whole)_index']),
            formatGrossValue(item.chillies__whole_index),
            formatGrossValue(item.turmeric_whole_index),
            formatGrossValue(item.salt_index),
            formatGrossValue(item.garam_masala_index),
            formatGrossValue(item.prepared_meal_and_refresment_index),
            formatGrossValue(item.prepared_sweets_index),
            formatGrossValue(item.biscuits_index),
            formatGrossValue(item.namkeen_index),
            formatGrossValue(item.non_alchohlic_beverages_index),
            formatGrossValue(item.tea_leaf_index),
            formatGrossValue(item.tea_cups_index),
            formatGrossValue(item.cold_drink_index),
            formatGrossValue(item.pan_supari_and_tabacco_beverages_index),
            formatGrossValue(item.average_of_pan_leaf_sada_and_supari_index),
            formatGrossValue(item.bidi_index),
            formatGrossValue(item.cigratte_index),
            formatGrossValue(item.tobacco_chewing_leaf_index),
            formatGrossValue(item.country_liquor_index),
            formatGrossValue(item.fuel_and_light_index),
            formatGrossValue(item.electricity_index),
            formatGrossValue(item.lpg_index),
            formatGrossValue(item.firewoods_index),
            formatGrossValue(item.dungcake_index),
            formatGrossValue(item.kerosene_index),
            formatGrossValue(item.match_box_index),
            formatGrossValue(item.candle_index),
            formatGrossValue(item.housing_index),
            formatGrossValue(item.average_of_raj_and_unskilled_labour_index),
            formatGrossValue(item.clothing__bedding_and_footwear_index),
            formatGrossValue(item.clothing_and_bedding_index),
            formatGrossValue(item.cloth_shirt_index),
            formatGrossValue(item.sari_index),
            formatGrossValue(item.dhoti_mardani_index),
            formatGrossValue(item.hosiery_baniyan_index),
            formatGrossValue(item.bedsheet_index),
            formatGrossValue(item.footwear_index),
            formatGrossValue(item.leather_shoes_index),
            formatGrossValue(item['leather_sandals_(ladies)_index']),
            formatGrossValue(item.rubber_or_pvc_footwear_chappal_index),
            formatGrossValue(item.miscellaneous_index),
            formatGrossValue(item.education_index),
            formatGrossValue(item.tutionfees_index),
            formatGrossValue(item.register_index),
            formatGrossValue(item.newspapers_index),
            formatGrossValue(item.medical_care_index),
            formatGrossValue(item.crocin_index),
            formatGrossValue(item.atin_50_index),
            formatGrossValue(item.daynil_index),
            formatGrossValue(item.cough_syrup_index),
            formatGrossValue(item.doctors_fees__at_clinic_index),
            formatGrossValue(item.blood_test_index),
            formatGrossValue(item.recreation_and_amusement_index),
            formatGrossValue(item.cinema_ticket_index),
            formatGrossValue(item['radio_(2_band)_index']),
            formatGrossValue(item.personal_care_and_effects_index),
            formatGrossValue(item.bathing__soap_index),
            formatGrossValue(item.hair_oil_index),
            formatGrossValue(item.toothpaste_index),
            formatGrossValue(item.telcom_powder_index),
            formatGrossValue(item.shaving_blades_index),
            formatGrossValue(item.household_and_requisties_index),
            formatGrossValue(item.agarbati_index),
            formatGrossValue(item.torch_index),
            formatGrossValue(item['battry_(dry_cell)_index']),
            formatGrossValue(item.washing_shop_index),
            formatGrossValue(item.unskilled_labour_index),
            formatGrossValue(item.tailor_index),
            formatGrossValue(item.barber_index),
            formatGrossValue(item.grinding_index),
            formatGrossValue(item.single_bed_index),
            formatGrossValue(item.thali_index),
            formatGrossValue(item.ceilling_fan_index),
            formatGrossValue(item.mobile_phone_or_handset_index),
            formatGrossValue(item.transport_and_communication_index),
            formatGrossValue(item.registerd_letter_index),
            formatGrossValue(item['telephone_charges_(bsnl)_index']),
            formatGrossValue(item.petrol_index),
            formatGrossValue(item.railway_fare_index),
            formatGrossValue(item.bus_fare_index),
            formatGrossValue(item.cycle_index),
            formatGrossValue(item.motor_cycle_index),
            formatGrossValue(item.others_index),
            formatGrossValue(item.gold_index),
            formatGrossValue(item.silver_index)
          ]);
          let redGroup = ['समस्त','खाद्य पेय पदार्थ और तंबाकू','अनाज और उत्पाद', 'दालें और उत्पाद', 'दूध और दूध उत्पाद',
            'तेल और वसा','मीट मछली और अंडे','सब्जियां','फल और सूखे फल','चीनी और गुरु आदि','मसालों और मसालों','तैयार भोजन और ताज़ा करना','गैर शराब पेय पदार्थ',
          'पैन सुपारी और तंबाकू पेय पदार्थ','ईंधन और प्रकाश','आवास','वस्त्र बिस्तर और जूते','कपड़े और बिस्तर',
          'जूते','कई तरह का','शिक्षा','चिकित्सा देखभाल','मनोरंजन और मनोरंजन','व्यक्तिगत देखभाल और प्रभाव','घरेलू और आवश्यकताएं',
          'परिवहन और संचार','अन्य लोग' ]

          const excelObjectData = {
            fileName: "PRIRuralDistrictIndex",
            fileType: 'xls',
            sheetName: 'PRIRuralDistrictIndex',
            firstRowMergeCells: "A1:DY1",
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowMergeCells: "A2:J2",
            secondRowText: `Price Rural District Index (${sDate}-${eDate}) (Base Year 2011-12=100)`,
            headerEnglishColumns: headerEnglishColumns,
            redGroup:redGroup
          };

          excelObjectData.excelRowData = [...additionalData];

          generateExcel(excelObjectData);
        } else {
          toast.error('Data is not found', messages.COLOR_RED);
        }
        showLoading(false);
      })
      .catch((error) => {
        console.error('API Error:', error);
        showLoading(false);
      });
  };






  return (
    <>
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.RURAL_DISTRICT_INDEX_REPORT : priceTitle.en.RURAL_DISTRICT_INDEX_REPORT }} />

              </h4>
              <div className="row align-items-center">
                {isDivision && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                    <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />

                  </div>
                )}

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">From Date</label>
                  <DatePicker
                    className="form-control calendar_icon"
                    selected={startDate}
                    onChange={(e) => { setStartDate(e) }}
                    dateFormat="MMM yyyy"
                    showMonthYearPicker
                    placeholderText="Select month"
                    maxDate={today}
                  />
                </div>


                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">To Date</label>
                  <DatePicker
                    className="form-control calendar_icon"
                    selected={endDate}
                    onChange={(e) => { setEndDate(e) }}
                    dateFormat="MMM yyyy"
                    showMonthYearPicker
                    placeholderText="Select month"
                    maxDate={today}
                  />
                </div>


                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}


export default DistrictIndex